module.exports = __webpack_public_path__ + "static/media/deliverAgentIco4.582be1c8.svg";